export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      portfolio: 'Portfolio',
      testimonials: 'Testimonials',
      contact: 'Contact',
      getStarted: 'Get Started'
    },
    hero: {
      title: 'Komorebi Homes',
      subtitle: '木漏れ日ホームズ',
      description: 'Where light filters through tradition to illuminate modern living. Experience Japanese craftsmanship and meticulous attention to detail.',
      exploreBtn: 'Explore Our Work',
      startBtn: 'Start Your Journey'
    },
    about: {
      sectionLabel: 'About Us',
      title: 'The Art of Japanese Home Building',
      description: 'Komorebi Homes specializes in creating bespoke residences that embody the essence of Japanese design philosophy. Each home is a testament to our commitment to craftsmanship, sustainability, and the harmonious balance between tradition and modernity.',
      values: {
        craftsmanship: {
          title: 'Master Craftsmanship',
          description: 'Every detail is crafted with precision by skilled artisans who honor traditional Japanese building techniques.'
        },
        harmony: {
          title: 'Natural Harmony',
          description: 'We design homes that breathe with nature, creating spaces where light, air, and materials coexist beautifully.'
        },
        design: {
          title: 'Timeless Design',
          description: 'Our philosophy blends minimalist aesthetics with functional elegance for homes that age gracefully.'
        },
        excellence: {
          title: 'Excellence',
          description: 'With over 15 years of experience, we deliver exceptional quality that exceeds expectations.'
        }
      },
      storyTitle: 'Our Story',
      storyPara1: 'Founded in 2010, Komorebi Homes was born from a passion for preserving traditional Japanese building methods while embracing contemporary living needs. Our name, meaning "sunlight filtering through trees," reflects our core philosophy of creating spaces where natural elements and human habitation exist in perfect harmony.',
      storyPara2: 'We work closely with each client to understand their vision, lifestyle, and dreams. From the first sketch to the final nail, we ensure every aspect of your home reflects the meticulous attention to detail that defines Japanese craftsmanship.'
    },
    services: {
      sectionLabel: 'Our Services',
      title: 'Comprehensive Custom Home Solutions',
      description: 'From initial concept to final construction, we provide comprehensive services to bring your dream home to life.',
      customDesign: {
        title: 'Custom Home Design',
        description: 'Tailored architectural designs that reflect your unique lifestyle and aesthetic preferences, rooted in Japanese design principles.',
        features: ['Personalized Consultation', 'Detailed Floor Plans', '3D Visualization']
      },
      planning: {
        title: 'Architectural Planning',
        description: 'Comprehensive planning services ensuring every detail aligns with building codes, sustainability goals, and your vision.',
        features: ['Site Analysis', 'Permit Coordination', 'Structural Engineering']
      },
      sustainable: {
        title: 'Sustainable Building',
        description: 'Eco-friendly construction using natural materials, energy-efficient systems, and designs that harmonize with the environment.',
        features: ['Natural Materials', 'Energy Efficiency', 'Green Certifications']
      },
      construction: {
        title: 'Full Construction',
        description: 'End-to-end construction management with master craftsmen who bring decades of experience and uncompromising quality.',
        features: ['Expert Craftsmen', 'Quality Control', 'Timeline Management']
      },
      ctaText: 'Ready to discuss your custom home project?',
      ctaBtn: 'Schedule a Consultation'
    },
    portfolio: {
      sectionLabel: 'Our Portfolio',
      title: 'Crafted with Precision & Passion',
      description: 'Explore a curated selection of our custom homes, each telling a unique story of craftsmanship and design excellence.',
      startProjectBtn: 'Start Your Project'
    },
    testimonials: {
      sectionLabel: 'Testimonials',
      title: 'What Our Clients Say',
      description: 'The trust our clients place in us is our greatest achievement. Here\'s what they have to say about working with Komorebi Homes.',
      ctaText: 'Join our family of satisfied homeowners',
      ctaBtn: 'Begin Your Journey'
    },
    contact: {
      sectionLabel: 'Contact Us',
      title: 'Let\'s Build Your Dream Home',
      description: 'We\'d love to hear about your vision. Reach out to us and let\'s start the conversation.',
      getInTouch: 'Get In Touch',
      intro: 'Whether you\'re ready to start your project or just exploring possibilities, we\'re here to help. Contact us today to schedule a consultation.',
      officeLocation: 'Office Location',
      address: '1-2-3 Sakura-cho, Kyoto-shi\nKyoto 600-0000, Japan',
      phone: 'Phone',
      phoneNumber: '+81 75-123-4567',
      hours: 'Mon-Fri: 9:00 AM - 6:00 PM JST',
      email: 'Email',
      emailAddress: 'info@komorebihomes.jp',
      nameLabel: 'Name',
      namePlaceholder: 'Your full name',
      emailLabel: 'Email',
      emailPlaceholder: 'your.email@example.com',
      phoneLabel: 'Phone',
      phonePlaceholder: '+81 90-1234-5678',
      messageLabel: 'Message',
      messagePlaceholder: 'Tell us about your project...',
      sendBtn: 'Send Message',
      sending: 'Sending...',
      successTitle: 'Message Sent Successfully!',
      successDesc: 'Thank you for contacting us. We\'ll get back to you soon.'
    },
    footer: {
      description: 'Crafting exceptional custom homes with Japanese precision and artistry since 2010.',
      quickLinks: 'Quick Links',
      contactTitle: 'Contact',
      followUs: 'Follow Us',
      followDesc: 'Stay connected for updates and inspiration.',
      copyright: '© 2025 Komorebi Homes. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    }
  },
  ja: {
    nav: {
      home: 'ホーム',
      about: '会社概要',
      services: 'サービス',
      portfolio: 'ポートフォリオ',
      testimonials: 'お客様の声',
      contact: 'お問い合わせ',
      getStarted: '始める'
    },
    hero: {
      title: 'Komorebi Homes',
      subtitle: '木漏れ日ホームズ',
      description: '伝統を通して光が差し込み、現代の暮らしを照らします。日本の職人技と細部へのこだわりを体験してください。',
      exploreBtn: '施工事例を見る',
      startBtn: '相談を始める'
    },
    about: {
      sectionLabel: '会社概要',
      title: '日本の家づくりの芸術',
      description: '木漏れ日ホームズは、日本のデザイン哲学の本質を体現するオーダーメイドの住宅を専門としています。各住宅は、職人技、持続可能性、そして伝統と現代性の調和のとれたバランスへの私たちのコミットメントの証です。',
      values: {
        craftsmanship: {
          title: '匠の技',
          description: '伝統的な日本の建築技術を尊重する熟練の職人によって、すべての細部が精密に作られています。'
        },
        harmony: {
          title: '自然との調和',
          description: '光、空気、素材が美しく共存する空間を創り出し、自然と呼吸する家をデザインします。'
        },
        design: {
          title: '時を超えるデザイン',
          description: '私たちの哲学は、ミニマリストの美学と機能的な優雅さを融合させ、優雅に年を重ねる家を作ります。'
        },
        excellence: {
          title: '卓越性',
          description: '15年以上の経験により、期待を超える卓越した品質をお届けします。'
        }
      },
      storyTitle: '私たちの物語',
      storyPara1: '2010年に設立された木漏れ日ホームズは、現代の生活ニーズを取り入れながら、伝統的な日本の建築方法を保存したいという情熱から生まれました。「木漏れ日」という私たちの名前は、自然の要素と人間の住居が完璧な調和の中に存在する空間を作るという、私たちの核心となる哲学を反映しています。',
      storyPara2: '私たちは各クライアントと密接に協力し、彼らのビジョン、ライフスタイル、そして夢を理解します。最初のスケッチから最後の釘まで、あなたの家のあらゆる側面が日本の職人技を定義する細部へのこだわりを反映していることを保証します。'
    },
    services: {
      sectionLabel: 'サービス',
      title: '包括的なカスタムホームソリューション',
      description: '初期のコンセプトから最終的な建設まで、あなたの夢の家を実現するための包括的なサービスを提供します。',
      customDesign: {
        title: 'カスタムホームデザイン',
        description: '日本のデザイン原則に基づいた、あなたのユニークなライフスタイルと美的嗜好を反映したオーダーメイドの建築デザイン。',
        features: ['個別相談', '詳細な平面図', '3Dビジュアライゼーション']
      },
      planning: {
        title: '建築計画',
        description: 'すべての詳細が建築基準、持続可能性の目標、そしてあなたのビジョンと一致することを保証する包括的な計画サービス。',
        features: ['敷地分析', '許可調整', '構造エンジニアリング']
      },
      sustainable: {
        title: '持続可能な建築',
        description: '自然素材、エネルギー効率の良いシステム、環境と調和するデザインを使用した環境に優しい建設。',
        features: ['自然素材', 'エネルギー効率', 'グリーン認証']
      },
      construction: {
        title: 'フル建設',
        description: '数十年の経験と妥協のない品質をもたらすマスタークラフトマンによるエンドツーエンドの建設管理。',
        features: ['熟練職人', '品質管理', 'スケジュール管理']
      },
      ctaText: 'カスタムホームプロジェクトについて話し合う準備はできていますか？',
      ctaBtn: '相談予約'
    },
    portfolio: {
      sectionLabel: 'ポートフォリオ',
      title: '精密さと情熱で作られた',
      description: 'それぞれが職人技とデザインの卓越性のユニークな物語を語る、私たちのカスタムホームの厳選されたセレクションをご覧ください。',
      startProjectBtn: 'プロジェクトを始める'
    },
    testimonials: {
      sectionLabel: 'お客様の声',
      title: 'お客様からの評価',
      description: 'お客様が私たちに寄せる信頼は、私たちの最大の成果です。木漏れ日ホームズとの仕事についてのお客様の声をご紹介します。',
      ctaText: '満足されたお客様のファミリーに参加しましょう',
      ctaBtn: '旅を始める'
    },
    contact: {
      sectionLabel: 'お問い合わせ',
      title: '夢の家を一緒に建てましょう',
      description: 'あなたのビジョンについてお聞かせください。お気軽にご連絡ください。',
      getInTouch: 'ご連絡ください',
      intro: 'プロジェクトを開始する準備ができている場合でも、可能性を探っているだけでも、私たちがお手伝いします。今すぐご連絡いただき、相談をスケジュールしてください。',
      officeLocation: 'オフィス所在地',
      address: '〒600-0000\n京都府京都市 桜町1-2-3',
      phone: '電話',
      phoneNumber: '075-123-4567',
      hours: '月〜金: 9:00 AM - 6:00 PM',
      email: 'メール',
      emailAddress: 'info@komorebihomes.jp',
      nameLabel: '名前',
      namePlaceholder: 'お名前',
      emailLabel: 'メールアドレス',
      emailPlaceholder: 'your.email@example.com',
      phoneLabel: '電話番号',
      phonePlaceholder: '090-1234-5678',
      messageLabel: 'メッセージ',
      messagePlaceholder: 'プロジェクトについてお聞かせください...',
      sendBtn: 'メッセージ送信',
      sending: '送信中...',
      successTitle: 'メッセージが送信されました！',
      successDesc: 'お問い合わせいただきありがとうございます。すぐにご連絡いたします。'
    },
    footer: {
      description: '2010年以来、日本の精密さと芸術性で卓越したカスタムホームを作り続けています。',
      quickLinks: 'クイックリンク',
      contactTitle: '連絡先',
      followUs: 'フォローする',
      followDesc: '最新情報とインスピレーションをお届けします。',
      copyright: '© 2025 木漏れ日ホームズ 全著作権所有',
      privacy: 'プライバシーポリシー',
      terms: '利用規約'
    }
  }
};